import api from "../axiosInstance";

export const getTutorProfileStatus = async () => {
  try {
    const response = await api.get("/tutors/profile/status");
    return response;
  } catch (error) {
    console.error("Get tutor completion status error:", error);
    throw error;
  }
};

export const updateTutorProfile = async (data) => {
  try {
    const response = await api.put("/tutors/profile", data);
    return response;
  } catch (error) {
    console.error("Update tutor profile error:", error);
    throw error;
  }
};
